import React from "react";
import "./styles.scss";
import CustomMenuItem from "./CustomMenuItem";

export interface MenuItem {
  text: string;
  isActive?: boolean;
  expandableData?: any;
  onClick(): void;
}

interface IProps {
  data: MenuItem[];
  expandable?: boolean;
}

const CustomMenu = (props: IProps) => {
  return (
    <div className="custom-menu-wrapper">
      <ul className="m-0 p-0" style={{ listStyle: "none" }}>
        {props.data.map((item, index) => (
          <CustomMenuItem
            data={item}
            key={index}
            expandable={props.expandable || false}
          />
        ))}
      </ul>
    </div>
  );
};

export default CustomMenu;
